const state = {
  supplierName: process.env.VUE_APP_SUPPLIER_NAME,
  supplierPhone: process.env.VUE_APP_SUPPLIER_PHONE,
  supplierEmail: process.env.VUE_APP_SUPPLIER_EMAIL,
  supplierTermsAndConditions: process.env.VUE_APP_TERMS_AND_CONDITIONS,
  supplierPrivacyPolicy: process.env.VUE_APP_PRIVACY_POLICY,

  nonDomesticMeterPhoneOpenHours: process.env.VUE_APP_DOMESTIC_METER_PHONE_OPEN_HOURS,
  nonDomesticMeterPhone: process.env.VUE_APP_NON_DOMESTIC_METER_PHONE,
  mprnHelpline: process.env.VUE_APP_MPRN_HELPLINE,

  whiteLabel: process.env.VUE_APP_WHITE_LABEL == 'true',
  gbData: process.env.VUE_APP_GB_DATA == 'true',
  carbonOffset: process.env.VUE_APP_CARBON_OFFSET == 'true',
  showGovernmentEnergyUpdate: process.env.VUE_APP_SHOW_GOV_ENERGY_UPDATE == 'true',
  referrerBranchCode: process.env.VUE_APP_REFERRER_BRANCH_CODE,
  switchOwnerReference: null
};

const getters = {};

const actions = {
  storeReferences(storeActions, { refererBranch, reference }) {
    sessionStorage.setItem('rb', refererBranch);
    sessionStorage.setItem('r', reference);
  },
  setReferences({ commit }) {
    const referBranch = sessionStorage.getItem('rb');
    const reference = sessionStorage.getItem('r');

    if (referBranch) {
      commit('updateState', { prop: 'referrerBranchCode', value: referBranch });
      commit('updateState', { prop: 'switchOwnerReference', value: reference });
    }
  }
};

const mutations = {
  updateState(state, { prop, value }) {
    state[prop] = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
